import React, { useEffect, useState } from "react";
import { Col, Row, Table } from "react-bootstrap";
import "./ReportClassTable.css";
import "./SencoStudentsResultsTable.css";
import {
  getSencoReportByClassId,
  getStudentClassDetail,
  getSencoReportBySchoolId,
} from "../services/APIClient";

function ExpandedSENWatchlistView(props) {
  const {
    students,
    showAtRiskOnly,
    setShowAtRiskOnly,
    classid,
    studentsReadingScore,
    schoolid,
    onDataReady, // Callback to pass data to parent
  } = props;

  console.log(schoolid);

  const dummyHeaderArray = [
    "Class",
    "SET",
    "Classroom Support Plan",
    "Details Of SET Received",
    "Priority Concerns",
    "Additional Needs",
    "Support Plan",
    "EAL",
    "Place on Continuum",
  ];

  const [sencoReportDetails, setSencoReportDetails] = useState([]);
  const [classNames, setClassNames] = useState({}); // Cache for class names

  const handleAtRiskFilterChange = (e) => {
    setShowAtRiskOnly(e.target.checked);
  };

  useEffect(() => {
    if (schoolid) {
      getSencoReportBySchoolId(schoolid)
        .then((response) => {
          console.log("SENCO Class Report Data:", response);
          setSencoReportDetails(response);
        })
        .catch((error) => console.error("Error fetching SENCO report:", error));
    }
  }, [schoolid]);

  // Fetch and cache class name for a student
  const fetchClassName = (studentId) => {
    if (!classNames[studentId]) {
      getStudentClassDetail(studentId)
        .then((classDetails) => {
          if (classDetails?.className) {
            setClassNames((prev) => ({
              ...prev,
              [studentId]: classDetails.className,
            }));
          }
        })
        .catch((error) =>
          console.error(
            `Error fetching class details for student ${studentId}:`,
            error
          )
        );
    }
  };

  const formatList = (items) => (
    <>
      {items?.map((item, index) => (
        <div key={index} className="item-list">
          {item}
        </div>
      ))}
    </>
  );

  const dataToDisplay = students.map((student) => {
    const matchingReport = sencoReportDetails.find(
      (report) => report.studentid === student.id
    ) || {
      classname: "",
      setname: "",
      classroomsupportplan: false,
      setreceived: [],
      priorityconcerns: [],
      additionalneeds: [],
      supportplan: [],
      eal: false,
      supportcontinuum: [],
    };

    // Trigger class name fetching
    fetchClassName(student.id);

    return {
      ...student,
      ...matchingReport,
      classname: classNames[student.id] || "Loading...",
    };
  });

  useEffect(() => {
    // Prepare the data to pass to the parent
    const data = {
      students: dataToDisplay, // Pass the processed data with all fields
      classid,
      showAtRiskOnly,
      studentsReadingScore,
      schoolid,
    };

    if (onDataReady) {
      onDataReady(data); // Pass data to parent
    }
  }, [
    dataToDisplay, // Ensure updated data is passed
    classid,
    showAtRiskOnly,
    studentsReadingScore,
    schoolid,
    onDataReady,
  ]);

  return (
    <Row>
      <Col>
        <div className="table-responsive">
          <Table className="custom-table">
            <thead>
              <tr>
                <th className="table-header-cell">Name</th>
                {dummyHeaderArray.map((header, index) => (
                  <th key={index} className="table-header-cell">
                    {header}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {dataToDisplay
                .filter(
                  (student) =>
                    !showAtRiskOnly ||
                    (student.readingScore !== undefined &&
                      student.readingScore !== null &&
                      student.readingScore <= 40)
                )
                .map((student) => (
                  <tr
                    key={student.id}
                    className="table-row student-results-table-row"
                  >
                    <td>{student.name}</td>
                    <td>{student.classname}</td>
                    <td>{student.setname}</td>
                    <td>{student.classroomsupportplan ? "Yes" : "No"}</td>
                    <td>{formatList(student.setreceived)}</td>
                    <td>{formatList(student.priorityconcerns)}</td>
                    <td>{formatList(student.additionalneeds)}</td>
                    <td>{formatList(student.supportplan)}</td>
                    <td>{student.eal ? "Yes" : "No"}</td>
                    <td>{formatList(student.supportcontinuum)}</td>
                  </tr>
                ))}
            </tbody>
          </Table>
        </div>
      </Col>
    </Row>
  );
}

export default ExpandedSENWatchlistView;
